module.exports = __webpack_public_path__ + "static/media/browserconfig.e4e40b0c.xml";